var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"render fit row q-pa-md",on:{"click":_vm.updateActiveComponent}},[_c('div',{staticClass:"col-12"},[_c('body-renderer',{attrs:{"body":_vm.template,"data":_vm.templateData,"teleportTo":_vm.teleportTo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }